export default {
      id: "steps-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#steps",
      toString: function () {
        return this.url;
      }
    }